import { render, staticRenderFns } from "./ListMain.vue?vue&type=template&id=e522efdc&scoped=true&"
import script from "./ListMain.vue?vue&type=script&lang=js&"
export * from "./ListMain.vue?vue&type=script&lang=js&"
import style0 from "./ListMain.vue?vue&type=style&index=0&id=e522efdc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e522efdc",
  null
  
)

export default component.exports